import React from 'react';
import { getAttachmentType } from '@/datasets/attachments/helper';
import { ATTACHMENT_TYPE } from '@/datasets/attachments/constants';
import RequestAttachmentCardItem from './RequestAttachmentCardItem';

const RequestAttachmentCardItems = ({ attachments, onCheckBoxClick, onFolderClick }) => attachments.map((item) => (
  <RequestAttachmentCardItem
    key={`attachment_list_item_${item.id}`}
    attachment={item}
    name={item.name}
    onCheckBoxClick={onCheckBoxClick}
    onFolderClick={getAttachmentType(item) === ATTACHMENT_TYPE.folde ? onFolderClick : undefined}
  />
));

export default RequestAttachmentCardItems;
